import { render, staticRenderFns } from "./UrgentNotice.vue?vue&type=template&id=0646332a&scoped=true&"
import script from "./UrgentNotice.vue?vue&type=script&lang=js&"
export * from "./UrgentNotice.vue?vue&type=script&lang=js&"
import style0 from "./UrgentNotice.vue?vue&type=style&index=0&id=0646332a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0646332a",
  null
  
)

export default component.exports